import { IDataRepo } from 'common/contracts';

export const DataHallRepo: IDataRepo[] = [
  {
    id: 'dataCenter/dataHall/AutroSafe',
    label: 'AutroSafe',
    position: {
      top: 56,
      left: 64,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/dataHall/AutroSense',
    label: 'AutroSense',
    position: {
      top: 64,
      left: 37,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/dataHall/Sounder',
    label: 'Sounder',
    position: {
      top: 31,
      left: 72,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/dataHall/ManualCallPoint',
    label: 'Manual Call Point',
    position: {
      top: 48,
      left: 14,
      unit: '%'
    }
  }
];
